import { int } from "@goodgamestudios/math-utilities";
import { GiftsVO } from "../../gamevo/GiftsVO";
import { Poker2Model } from "../Poker2Model";

export class Poker2GiftData {

    private _gifts: any[];
    private _myGifts: any[];

    constructor() {
    }

    public buildGifts(voList: Map<any, any>): void {
        this._gifts = new Array();
        if (voList != null) {
            for (let entryList of Array.from(voList.values())) {
                var element: any = entryList;
                if (element === undefined) { continue; }

                if (instanceOfClass(element, "GiftsVO"))
                    this._gifts.push(element);
            }
        }
    }

    public parse_GMG(paramObject: any[]): void {
        this._myGifts = new Array();
        if (!paramObject || (<any>paramObject).I.length < 1)
            return;

        for (let entryList of (<any>paramObject).I) {
            var item: any = entryList;
            if (item === undefined) continue;

            var giftVO: GiftsVO = castAs<GiftsVO>(Poker2Model.wodData.getItemVObyID(item.shift()), "GiftsVO");
            if (giftVO) {
                giftVO.inventoryAmount = 1;
                giftVO.timeleft = Date.now() + int(item.shift());
                this._myGifts.push(giftVO);
            }
        }
    }

    public get gifts(): any[] {
        return this._gifts.sort(this.bindFunction(this.sortByLevelMoney));
    }

    public get myGifts(): any[] {
        return this._myGifts.sort(this.bindFunction(this.sortByLevelMoney));
    }

    /**
     *  eine negative Zahl, falls x in der sortierten Reihenfolge vor y auftritt
     * 0, falls x gleich y ist
     * eine positive Zahl, falls x in der sortierten Reihenfolge nach y auftritt
     */
    private sortByLevelMoney(x: GiftsVO, y: GiftsVO): number {
        if (x.priceChips < y.priceChips) return -1;
        if (x.priceChips > y.priceChips) return 1;
        if (x.priceGold < y.priceGold) return -1;
        if (x.priceGold > y.priceGold) return 1;
        return 0;
    }
}

import { castAs } from "@goodgamestudios/createjs-utilities";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
